import React from 'react';

import { Link } from '@mui/material';

import styles from './AdminLink.module.css';

export function AdminLink() {
  return (
    <Link className={styles.hidden_features} href="/admin">
      _
    </Link>
  );
}
